module.exports = __webpack_public_path__ + "static/usluge_img_1-726344b2fec083eba2332ff14118fb6c.jpg";